import { ReactNode } from 'react'
import { NavArrowDown } from '../at-icon'
import { cn } from '../../utils/cn'

export const Pill = ({
  label = '',
  value = '',
  valueIcon,
  open = false,
  disabled = false,
  className,
  arrowClassName,
}: {
  label?: string
  value?: string
  /** Optional icon to show to the left of the value when displayed (e.g. MapPin for geo-selected city) */
  valueIcon?: ReactNode
  open?: boolean
  disabled?: boolean
  /** Extra Tailwind classes for the pill (e.g. rounded-[1.5rem], padding, colors). Merged with defaults. */
  className?: string
  /** Extra Tailwind classes for the arrow icon (e.g. text-neutrals-white). Overrides default color. */
  arrowClassName?: string
}) => (
  <div
    className={cn(
      'text-14 leading-1.5 min-w-max h-10 rounded-[6.25rem] border-1 group-focus-visible:border-neutrals-800 inline-flex items-center justify-between gap-2 pl-4 pr-2 py-2',
      !disabled && 'group-hover:border-neutrals-800',
      disabled ? 'text-neutrals-350' : 'text-neutrals-800',
      disabled ? 'border-neutrals-350' : value || open ? 'border-neutrals-800' : 'border-neutrals-600',
      className
    )}
  >
    {value ? (
      <span className="flex items-center gap-2 min-w-0">
        {valueIcon != null && <span className="shrink-0 [&_svg]:w-4 [&_svg]:h-5">{valueIcon}</span>}
        {value}
      </span>
    ) : (
      label
    )}
    <div className="w-10 flex justify-center items-center">
      <NavArrowDown
        className={cn(open && 'rotate-180', arrowClassName ?? (disabled ? 'text-neutrals-350' : 'text-neutrals-800'))}
      />
    </div>
  </div>
)
